import { __spreadArray } from 'tslib';
import clsx from 'clsx';
import styles from '../LeftNavAppMenu.module.scss.js';

var getLinkClassName = function (link, className) {
    var additionalClassNames = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalClassNames[_i - 2] = arguments[_i];
    }
    return clsx.apply(void 0, __spreadArray([styles[className],
        link.isActive && styles[className + "___active"]], additionalClassNames, false));
};

export { getLinkClassName };
